import { styled } from '@nykaa/ui-components';
import BaseInput from 'shared/components/Input';
import { BaseButton } from 'shared/styles/mixin';

export const Input = styled(BaseInput)`
  width: 350px;
  margin: ${({ theme }) => `${theme.spacing.spacing80} ${theme.spacing.spacing100}`};
  ${({ theme }) => theme.typography.bodyLarge};
  color: ${({ theme }) => theme.colors.textPrimary};
  & .input::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const BrandInitial = styled.div`
  height: 24px;
  width: 100%;
  background: linear-gradient(0deg, rgba(101, 119, 134, 0.08), rgba(101, 119, 134, 0.08)), #ffffff;
  padding-left: ${({ theme }) => theme.spacing.spacing100};
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.bodyMedium}
`;

export const AllBrands = styled.div`
  width: 100%;
  min-height: 90vh;
  background: #f3f3f3;
  ${({ theme }) => theme.typography.bodyMedium};

  .content-wrapper {
    display: flex;
    width: 70%;
    margin: 0 auto;
    padding-top: ${({ theme }) => theme.spacing.spacing100};
    padding-bottom: ${({ theme }) => theme.spacing.spacing100};
  }

  :last-child > .content {
    border-bottom: 0;
  }

  .left-section {
    margin-right: ${({ theme }) => theme.spacing.spacing80};
    width: 30%;
  }
  .right-section {
    width: 70%;
    background: #fff;
  }
`;

export const MenuItem = styled.div<{ selected?: boolean }>`
  height: 56px;
  background: #fff;
  display: flex;
  justify-content: center;
  cursor: pointer;

  .content {
    justify-content: space-between;
    display: flex;
    align-items: center;
    width: 90%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
    text-decoration: none;
    ${({ theme, selected }) =>
    selected ? theme.typography.titleSmall : theme.typography.bodyLarge};
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  .right-content {
    justify-content: space-between;
    display: flex;
    align-items: center;
    width: 90%;
    border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
    text-decoration: none;
    ${({ theme }) => theme.typography.bodyLarge};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
  border-left: 4px solid #fff;
  font-weight: ${({ selected }) => (selected ? 500 : 400)};

  ${({ selected, theme }) => selected && `border-left: 4px solid ${theme.colors.secondary};`}

  &:hover {
    background: ${({ theme }) => theme.colors.stateHover};
    border-left: 4px solid ${({ theme }) => theme.colors.textOutline};
  }

  transition: all 0.2s ease;
`;

export const AvailableInitials = styled.div`
  .menu-item {
    :last-child > .content {
      border-bottom: 0;
    }
  }
`;

export const AllBrandsHeading = styled.h1`
  ${({ theme }) => theme.typography.bodyLarge};
  color: ${({ theme }) => theme.colors.textPrimary};
  height: 56px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  justify-content: space-between;
  display: flex;
  align-items: center;
  width: 90%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
  text-decoration: none;
  margin: 0;
`;

export const ClearButton = styled(BaseButton)`
  height: 24px;
  width: 24px;
  font-size: 24px;
  object-fit: contain;
  opacity: 0.64;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 12px;
`;

export const IconSearchWrapper = styled.span`
  padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
  display: flex;
`;

export const InputContainer = styled.div`
  position: relative;
`;
